import { useSearchParams } from 'react-router';
import ListTourPackage from './ListTourPackage';
import FormTour from './FormTourPackage';

export default function Tour() {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'list';

  return (
    <section>
      {activeTab === 'list' && <ListTourPackage />}
      {activeTab === 'form' && <FormTour />}
    </section>
  );
}
